<template>
  <template v-if="suggestion.name === 'recentSearch'">
    <location-wizard-recent-search-suggestion
      :query="query"
      :suggestion="suggestion.item"
      class="suggestion"
    />
  </template>
  <location-wizard-hierarchy-suggestion
    v-else-if="suggestion.name === 'hierarchy'"
    :query="query"
    :suggestion="suggestion.item"
    class="suggestion"
  />
  <location-wizard-campsite-suggestion
    v-else-if="suggestion.name === 'campsite'"
    :query="query"
    :suggestion="suggestion.item"
    class="suggestion"
  />
  <location-wizard-custom-suggestion
    v-else-if="suggestion.name === 'custom'"
    :query="query"
    :suggestion="suggestion.item"
    class="suggestion"
  />
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import type { LocationWizardSuggestion } from './types'

@Component({
  components: {
    'location-wizard-recent-search-suggestion': defineAsyncComponent(
      () =>
        import(
          './non-autoload-components/LocationWizardRecentSearchSuggestion.vue'
        ),
    ),
    'location-wizard-hierarchy-suggestion': defineAsyncComponent(
      () =>
        import(
          './non-autoload-components/LocationWizardHierarchySuggestion.vue'
        ),
    ),
    'location-wizard-campsite-suggestion': defineAsyncComponent(
      () =>
        import(
          './non-autoload-components/LocationWizardCampsiteSuggestion.vue'
        ),
    ),
    'location-wizard-custom-suggestion': defineAsyncComponent(
      () =>
        import('./non-autoload-components/LocationWizardCustomSuggestion.vue'),
    ),
  },
})
class LocationWizardSuggestionLine extends Vue {
  @Prop()
  query: string

  @Prop()
  suggestion: LocationWizardSuggestion
}

export default toNative(LocationWizardSuggestionLine)
</script>

<style scoped>
.suggestion {
  align-items: flex-start;
  border-bottom: 1px solid #dbdfe6;
  display: flex;
  font-size: var(--body);
  justify-content: flex-start;
  line-height: 1.1;
  overflow: hidden;
  padding: 0.5em 1.1em 0.5em 1em;
}

.suggestion :deep(.suggestion-type) {
  color: var(--colour-text-light);
  display: block;
  font-size: smaller;
  line-height: 1;
}

.suggestion :deep(.suggestion-icon) {
  display: block;
  width: 2.3em;
  height: 2.3em;
  border-radius: 50%;
  background: #dbdfe6;
  flex-shrink: 0;
  margin-right: 0.5em;
}

.suggestion :deep(.suggestion-icon.svg) {
  display: flex;
  align-items: center;
  justify-content: center;
}

.suggestion :deep(.suggestion-icon.svg img) {
  width: 76%;
  height: auto;
}

.suggestion.recent-searches :deep(.suggestion-icon) {
  background: none;
  opacity: 0.4;
  filter: contrast(0.5);
}

.suggestion.recent-searches :deep(.suggestion-type strong) {
  font-weight: normal;
}

.suggestion.recent-searches :deep(.suggestion-type > span:after) {
  content: ', ';
}

.suggestion.recent-searches :deep(.suggestion-type > span:last-child:after) {
  content: '';
}

.suggestion.recent-searches :deep(.category-icons) {
  display: inline-flex;
  justify-content: start;
}

.suggestion.recent-searches :deep(.category-icons img) {
  height: 0.8em;
}

.suggestion :deep(.count) {
  color: var(--colour-text-light);
  font-size: smaller;
  line-height: 1;
  margin-left: auto;
  text-align: right;
  text-wrap-style: balance;
}

.suggestion :deep(.suggestion-term) {
  font-weight: 600;
  color: #111;
}

.suggestion :deep(.suggestion-term mark) {
  font-weight: normal;
  background: none;
  border-radius: 0;
  color: #333;
}

.suggestion :deep(.suggestion-details) {
  width: 100%;
}

.suggestion :deep(.row) {
  justify-content: space-between;
  margin-top: 0.25em;
  column-gap: 1.75em;
}

.suggestion :deep(.suggestion-type img) {
  vertical-align: baseline;
}

.suggestion :deep(.suggestion-poi-category) {
  text-transform: capitalize;
}
</style>
